export class PolyPerformanceformanceController {
  setPerformanceManager(p) {
    this._performanceManager = p;
  }
  performanceManager() {
    return this._performanceManager || window.performance;
  }
}
